<template>
  <div>
    <h2 class="text-primary">Store Builder</h2>
    <p>Tell us how you will use your site.</p>
    <StoreBuilderForm @success="next" @back="back" :enableBack="!storeBuilderUi" />
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import StoreBuilderForm from "@/components/smart/forms/StoreBuilderForm";

export default {
  name: "CheckoutStoreBuilderPage",
  components: {
    StoreBuilderForm,
  },
  setup(props, context) {
    const storeBuilderUi = computed(() => store.getters["checkout/requireStoreBuilderUi"]);

    const back = () => {
      context.root.$router.push({
        name: "checkout-details",
        query: store.getters["checkout/getQueryParams"],
      });
    };

    const next = () => {
      context.root.$router.push({
        name: "checkout-billing",
        query: store.getters["checkout/getQueryParams"],
      });
    };

    onMounted(() => {
      if (
        !store.state.checkout.appId ||
        !store.state.checkout.packageId ||
        !store.getters["auth/isLoggedIn"]
      ) {
        back();
      } else {
        store.dispatch("checkout/autoRedirect", false);
      }
    });

    return {
      next,
      back,
      storeBuilderUi,
    };
  },
};
</script>
